/** Local-device calendar day as 'YYYY-MM-DD' (content-schemas §0 dayKey). Sortable as a string. */
export function dayKeyOf(wallMs: number): string {
  const d = new Date(wallMs);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${String(d.getFullYear())}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
